var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('framed-content',{attrs:{"title":_vm.formTitle}},[_c('div',{class:( _obj = {'grid-display': true}, _obj[_vm.columnsClass] = true, _obj )},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }